import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import NewMediaStatistics from './NewMediaStatistics';
import CompareStatistics from './CompareStatistics';
import NewMediaMcStatistics from './NewMediaMcStatistics';
import MediaRevenueStatistics from './MediaRevenueStatistics';

const MediaStatistics = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="MediaStatistics"
        tabMenuList={tabList()}
        tabs={{
          // 운영수익
          '/master/report/revenue': {
            tabComponent: (
              <>
                <MediaRevenueStatistics />
              </>
            ),
          },
          '/master/report/media_new': {
            tabComponent: (
              <>
                <NewMediaStatistics />
              </>
            ),
          },
          '/master/report/compare': {
            tabComponent: (
              <>
                <CompareStatistics />
              </>
            ),
          },
          // new지면별통계
          '/master/report/media_new_mc': {
            tabComponent: (
              <>
                <NewMediaMcStatistics />
              </>
            ),
          },
        }}
      ></MbTabs>
    </MainTemplate>
  );
};

export default MediaStatistics;
